import { render, staticRenderFns } from "./rankCarousel.vue?vue&type=template&id=33d66972&scoped=true&"
import script from "./rankCarousel.vue?vue&type=script&lang=js&"
export * from "./rankCarousel.vue?vue&type=script&lang=js&"
import style0 from "./rankCarousel.vue?vue&type=style&index=0&id=33d66972&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d66972",
  null
  
)

export default component.exports